import React from 'react';
import {connect} from 'react-redux';
import styles from './css/Search.styl';

/**
 * Funeral Home Faceted Search module
 * @class   Search
 * @return  {JSX}     Returns the rendered module
 */
export class Search extends React.Component {
  static propTypes = {
    ads: React.PropTypes.object.isRequired,
    funeralHomes: React.PropTypes.array.isRequired,
  };

  /**
   * Funeral Home Faceted Search React Component constructor
   * @param       {Object}    props   Passed in props
   * @constructs  {Search}
   * @return      {Undefined} Returns nothing
   */
  constructor(props) {
    super(props);
  }

  /**
   * React Component render.
   * @return {JSX} Faceted Search page rendered.
   */
  render() {
    const funeralHomes = this.props.funeralHomes;

    return (
      <div className={styles.Search}>
        Arrived At Faceted Search
        <div>
          Search Retrieved {funeralHomes.length} Homes
          <ul>
            {funeralHomes.map((fh, key) => (
              <li key={key} style={{padding: '10px'}}>
                <div>
                  {fh.name} -{' '}
                  {fh.premiumSubscriber ? 'A Partner Home' : 'A Standard Home'}
                </div>
                <div>
                  {fh.address1}, {fh.city}, {fh.state}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ads: state.adStore,
  funeralHomes: state.searchFuneralHomesStore.funeralHomes,
});

export default connect(mapStateToProps)(Search);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Search/index.js